import { SortType } from '../models/sorttype';
import { createAction, props } from '@ngrx/store';

export interface ResourceLoadResponse<T = any> {
	total: number;
	results: T[];
}

export interface ResourceGetResponse<T = any> {
	result: T;
}

export interface ResourceSaveResponse {
	AllErrors: any[];
	FieldErrors: any;
	GlobalErrors: any[];
	Message: string;
	Successful: boolean;
}

export interface ResourceDeleteResponse {
	AllErrors: any[];
	FieldErrors: any;
	GlobalErrors: any[];
	Message: string;
	Successful: boolean;
}

export interface ResourcePagination {
	Page?: number;
	PageSize?: number;
	Total?: number;
}

export interface ResourceSort {
	name: string;
	ascending: boolean;
}

export interface ResourceFilterItem {
	name: string;
	value: any;
}

export interface ListRequestOptions {
	Page?: number;
	PageSize?: number;
	Filter?: string;
	Sort?: number;
	SortType?: SortType;

	// Structured filters - only the fields relevant to a given entity are read on the backend (see
	// each entity's manager GetListFilter); the rest are simply omitted from the request.
	Discipline?: number;
	// Tournament list only - ORed together, unlike the single-value Discipline above which Matches
	// also filters by.
	Disciplines?: number[];
	DateFrom?: string;
	DateTo?: string;
	MatchType?: number;
	MatchStatus?: number;
	TournamentType?: number[];
	TournamentStatus?: number[];
	IsDoublesTournament?: boolean[];
	City?: string;
}

export enum StateError {
	None,
	Unknown,
	NoInternetAccess,
	ServerError,
}

export interface ResourceState<R = any> {
	Items: R[];
	Loading: boolean;
	Query: ListRequestOptions;
	Total: number;
	Error: StateError;
}

export const HydrateStoreAction = createAction(
	'[App] Hydrate Store',
	props<{ store: any }>()
);

export const ClearFeatureStateAction = createAction(
	'[App] Clear Feature State'
);

// A single cached value with its own loading flag, for feature slices that aren't a paged list
// (ResourceState above) - e.g. one statistics record per userId, one badges list per userId.
export interface CachedValue<T> {
	data: T;
	loading: boolean;
}
